import styled from 'styled-components'
import { CallNotesForm } from 'features/calls/components'

interface IProps {
  callId: string
  disabled: boolean
}

const CallNotes = ({ callId, disabled }: IProps) => {
  return (
    <Section>
      <section className="header">
        <h3>Call Notes</h3>
      </section>
      <section className="body">
        <CallNotesForm callId={callId} disabled={disabled} />
        <span className="notes-message">Notes are saved automatically.</span>
      </section>
    </Section>
  )
}

const Section = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: ${({ theme }) => theme.constants.navbarHeight};
    width: 100%;
    display: flex;
    background-color: ${({ theme }) => theme.colors.info.lightest};
    justify-content: start;
    align-items: center;
    padding-left: ${({ theme }) => theme.util.pixelToRem(34)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.lighter};
    h3 {
      font-family: 'Milliard';
      font-style: normal;
      font-weight: 600;
      font-size: 1.25rem;
      line-height: 150%;
      color: ${({ theme }) => theme.colors.primary.darker};
    }
  }

  .body {
    background-color: ${({ theme }) => theme.colors.info.lightest};
    height: ${({ theme }) => theme.util.subtractFromAbsoluteViewportHeight(theme.constants.navbarHeight, 3)};
    padding: 0.75rem 1rem;
    display: flex;
    flex-direction: column;

    .notes-message {
      padding-top: 0.75rem;
      align-self: center;
      ${({ theme }) => theme.typography.s.normal};
      color: ${({ theme }) => theme.colors.grey.light};
    }
  }
`

export { CallNotes }
